import {
  bl_fi_budget_generic_doc_hdr_RowClass,
  bl_fi_budget_generic_doc_hdr_RowInterface,
  bl_fi_budget_generic_doc_line_RowClass,
} from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";

export class BudgetGenericDocContainerModel extends BaseContainerModel {
  bl_fi_budget_generic_doc_hdr: bl_fi_budget_generic_doc_hdr_RowInterface =
    new bl_fi_budget_generic_doc_hdr_RowClass();
  bl_fi_budget_generic_doc_lines: bl_fi_budget_generic_doc_line_RowClass[] = [];
}
